export var LocalStorageEnum;
(function (LocalStorageEnum) {
    LocalStorageEnum["Login"] = "Login";
    LocalStorageEnum["Url"] = "Url";
})(LocalStorageEnum || (LocalStorageEnum = {}));
